export class ServerError {
  message: string | undefined;
  code: string;

  static ERR_SYSTEM = 'SYSTEM';
  static ERR_NOT_SIGNED_IN = 'NOT_SIGNED_IN';
  static ERR_AUTHENTICATION = 'AUTHENTICATION';
  static ERR_INVALID_INPUT = 'INVALID_INPUT';
  static ERR_RESOURCE_NOT_FOUND = 'RESOURCE_NOT_FOUND';
  static ERR_JWT = 'JWT';
  static ERR_EMAIL_ADDRESS_UNAVAILABLE = 'EMAIL_ADDRESS_UNAVAILABLE';
  static ERR_SERIALIZATION = 'SERIALIZATION';
  static ERR_GATEWAY_INVALID_RESPONSE = 'GATEWAY_INVALID_RESPONSE';
  static ERR_GATEWAY_NO_CONNECTION = 'GATEWAY_NO_CONNECTION';
  static ERR_GATEWAY_UNHANDLED_REDIRECT = 'GATEWAY_UNHANDLED_REDIRECT';
  static ERR_GATEWAY_INVALID_REQUEST = 'GATEWAY_INVALID_REQUEST';
  static ERR_GATEWAY_SERVER_ERROR = 'GATEWAY_SERVER_ERROR';
  static ERR_GATEWAY_APP = 'GATEWAY_APP';
  static ERR_RECORD_NOT_CREATED = 'RECORD_NOT_CREATED';
  static ERR_DATABASE_EMPTY_RECORDSET = 'DATABASE_EMPTY_RECORDSET';
  static ERR_DATABASE_SYSTEM = 'DATABASE_SYSTEM';
  static ERR_DATABASE_UNEXPECTED_RECORD_COUNT =
    'DATABASE_UNEXPECTED_RECORD_COUNT';

  constructor(m: Partial<ServerError>) {
    if (!m.code) {
      throw new Error(
        `Invalid code in constructor: ${JSON.stringify(m)} code cannot be null`,
      );
    }

    this.message = m.message;
    this.code = m.code;
  }
}
